import * as yup from 'yup';
import { FIELD_LIMITS } from 'utils/character-count-utils';

const badgeModalFormValidation = yup.object().shape({
  badgeTitle: yup.string().trim().required('Title is a required field').max(FIELD_LIMITS.BADGE_TITLE.maxLength, `Badge title must be at most ${FIELD_LIMITS.BADGE_TITLE.maxLength} characters`),
  badgeDescription: yup.string().trim().max(FIELD_LIMITS.BADGE_DESC.maxLength, `Badge description must be at most ${FIELD_LIMITS.BADGE_DESC.maxLength} characters`),
  badgeImgUrl: yup.string().trim().required('Badge Image is a required field'),

});

export const badgeFieldConfigs = {
  title: FIELD_LIMITS.BADGE_TITLE,
  description: FIELD_LIMITS.BADGE_DESC,
};

export default badgeModalFormValidation;
